<template>
  <div class="account-card">
    <div
      class="cursor-pointer no-select login-text"
      @mouseenter="signInShow"
      @mouseleave="signInHide"
      v-if="!userData"
    >
      Вход/Регистрация {{ userData }}
    </div>
    <div
      class="cursor-pointer no-select login-text"
      @mouseenter="userShow"
      @mouseleave="userHide"
      v-else
    >
      {{ userData[0].email }}
    </div>

    <div
      v-if="signInClick"
      @mouseenter="signInShow"
      @mouseleave="signInHide"
      class="account-card--signin"
    >
      <div>
        <router-link tag="a" :to="`/login/`"
          ><f-awesome icon="sign-in-alt"></f-awesome> Войти</router-link
        >
      </div>
      <div>
        <router-link tag="a" :to="`/register/`"
          ><f-awesome icon="user-plus"></f-awesome> Регистрация</router-link
        >
      </div>
    </div>

    <div
      v-if="userClick"
      @mouseenter="userShow"
      @mouseleave="userHide"
      class="account-card--out"
    >
      <div>
        <router-link tag="a" :to="`/journal/`"
          ><f-awesome icon="sign-in-alt"></f-awesome> Личный
          кабинет</router-link
        >
      </div>
      <div class="cursor-pointer" @click="logout">
        <f-awesome icon="times"></f-awesome> Выйти
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AccountCard",
  data() {
    return {
      signInClick: false,
      userClick: false
    };
  },
  computed: {
    ...mapState({
      userData: state => state.authorization.userData
    })
  },
  methods: {
    signInShow() {
      this.signInClick = true;
    },
    signInHide() {
      this.signInClick = false;
    },
    userShow() {
      this.userClick = true;
    },
    userHide() {
      this.userClick = false;
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  },
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.login-text {
  color: #f97979;
}
.account-card {
  position: relative;
}
.account-card--signin,
.account-card--out {
  line-height: 20px;
  position: absolute;
  left: -15px;
  width: 150px;
  height: 80px;
  background-color: rgba(60, 73, 89, 0.8);
  z-index: 9999;

  & > div {
    padding: 0 0 0 15px;
    box-sizing: border-box;
    margin-top: 10px;
  }
}
@media (max-width: 700px) {
  .account-card--signin,
  .account-card--out {
    line-height: 20px;
    position: absolute;
    right: 10px;
  }
}
</style>
